import Quill from 'quill-next';

const Inline = Quill.import('blots/inline') as any;

export class ListeningArticleHighlight extends Inline {
  static blotName = 'listening-article-highlight';
  static className = 'ql-l-article-highlight';
  static tagName = 'span';

  static create(value: any) {
    const dom = super.create(value);
    const s = typeof value === 'number' ? `(Q${value})` : value;
    dom.dataset.question = s;
    if (s === ' ') {
      dom.dataset.labelVisible = 'false';
    } else {
      dom.dataset.labelVisible = 'true';
    }

    return dom;
  }

  static formats() {
    return true;
  }
}
